module.exports = __webpack_public_path__ + "images/63a0335403c9c238c8d4b71a64a5a31d.svg";